/** Inform about a field-read grant without turning it into site navigation. */
export default function PersonalDataConsentNotice({
  applicationLabel,
  resourceLabel,
  permissionLabel,
  message,
  consentUrl,
}: {
  applicationLabel: string;
  resourceLabel: string;
  permissionLabel: string;
  message: string;
  consentUrl: string;
}) {
  return <aside className="personal-data-consent-notice" role="status" aria-label={resourceLabel}>
    <span className="personal-data-consent-notice__icon" aria-hidden="true">ⓘ</span>
    <span>
      <strong>{applicationLabel} · {resourceLabel} · {permissionLabel}:</strong>{" "}
      <a href={consentUrl}>{message}</a>
    </span>
  </aside>;
}
